import * as Yup from 'yup';

export interface CustomInvoiceItemFormType extends Record<string, unknown> {
    text: string;
    textFrench: string;
    textDeutsch: string;
    price: number | string;
    quantity: number | string;
}

export const initialCustomInvoiceItem: CustomInvoiceItemFormType = {
    text: '',
    textFrench: '',
    textDeutsch: '',
    price: '',
    quantity: 1,
};

export const customInvoiceItemSchema = Yup.object().shape({
    text: Yup.string().max(255),
    textFrench: Yup.string().required('schemaRequiredDescription').max(255),
    textDeutsch: Yup.string().max(255),
    price: Yup.number()
        .typeError('schemaRequiredPrice')
        .required('schemaRequiredPrice')
        .min(0)
        .test('max-decimals', 'schemaMaxDecimals', (value) => {
            if (value === undefined || value === null) return true;
            const decimalPart = String(value).split('.')[1];
            return !decimalPart || decimalPart.length <= 2;
        }),
    quantity: Yup.number()
        .typeError('schemaRequiredQuantity')
        .required('schemaRequiredQuantity')
        .integer('schemaQuantityMin')
        .min(1, 'schemaQuantityMin'),
});